<script>
import AppointmentRequest from './appointment-request.vue'
export default {
  components: { AppointmentRequest },
  props: {
    contactId: {type: String, required: true},
  },

  data() {
    return {
      observed: this.$storage.observed,
      userUuid: this.$storage.getUserUuid(),
      directChannel: this.$storage.getDirectChannel(this.contactId),
      displayAppRequestForm: false,
    }
  },

  watch: {
    'observed.directChannels': function () {
      let me = this
      setTimeout(function() {
        me.directChannel = me.$storage.getDirectChannel(me.contactId)
      }, 500);
    }
  },

  methods: {
    routeToPrivateChannel(channel, params={}) {
      this.$router.push({path: `/community/${this.contactId}/${channel.id}`, query: params})
    },

    onPrivateMessage(data) {
      if (!this.directChannel) {
        let me = this
        this.$chat.post('channels/direct/', {user_uuid: this.contactId}).then(function(response) {
          console.log('created channel: ', response)
          me.directChannel = response.data
          me.routeToPrivateChannel(me.directChannel, data)
        })
      } else
        this.routeToPrivateChannel(this.directChannel, data)
    },

    getEndTime(startTime, mins) {
      let date = new Date()
      const [hh, mm] = startTime.split(':').map(Number)
      date.setUTCHours(hh, mm + mins, 0, 0)
      return date.toISOString().slice(11,16)
    },

    onAppointmentRequest(info) {
      this.displayAppRequestForm = false
      let endTime = this.getEndTime(info.time, info.duration)
      let message = `:calendar: Terminanfrage: **${info.date}** ${info.time}\u2013${endTime} Uhr \u2014 ${info.subject}`
      this.onPrivateMessage({
        message: message,
        meeting_date: info.date,
        meeting_time: info.time,
        meeting_end: endTime,
        meeting_subject: info.subject,
      })
    }
  },
}
</script>

<template>
  <div>
    <button @click.prevent="onPrivateMessage" class="btn btn-secondary">
      Nachrichten&nbsp;<span v-if="directChannel && directChannel.numUnreadMessages" class="badge bg-danger">{{ directChannel.numUnreadMessages }}</span>
    </button>
    <button @click.prevent="displayAppRequestForm = !displayAppRequestForm"
     class="btn btn-secondary ms-1">
      Termin-Anfrage
    </button>
    <appointment-request v-if="displayAppRequestForm"
     @submit="onAppointmentRequest($event)"
     @cancel="displayAppRequestForm = false" 
     class="mt-3"
    />
  </div>
</template>
